import * as React from 'react';
import propz from 'propz';
import BPromise from 'bluebird';
import { parse } from 'query-string';
import { History, Location } from 'history';
import moment from 'moment';
import { AppUser } from 'Src/views/App/App';
import { Component } from 'react';
import { Loader } from 'Src/components/Loader/Loader';
import { ClubBookingCard } from 'Src/components/ClubBookingCard/ClubBookingCard';
import { SimpleModal } from 'Src/components/SimpleModal/SimpleModal';
import { MessageField, EventInvitationMessage } from 'Src/models/message';
import { FormSubmission } from 'Src/types/formSchema';
import { Map } from 'Src/components/Map/Map';
import { DATE_INTERVAL, FILTER_TYPE, FIRST_PAGE, CARD_LIMIT } from 'Src/consts/table';
import {
  ColumnDefinition,
  getFilters2,
  getServerQueryFilter2,
  isFilterExist2,
  isSortExist,
  TABLE_SORT_DIRECTION,
  getSearchFilter,
  getSearchOrder,
  getOrder
} from 'Src/helpers/table/table';
import { Pagination2 } from 'Src/components/Pagination/Pagination2';
import { INVITE_TYPE } from 'Src/consts/invite';
import { ClubInvitationForm } from 'Src/components/ClubInvitationForm/ClubInvitationForm';
import { setMessageWaitingStatus } from 'Src/helpers/service/parent/messagesTable';
import { ClubBookingDeatils } from 'Src/views/GenericView/ParentView/ClubBookings/ClubBookingDetails/ClubBookingDetails';
import {
  getStudentInboxMessages,
  getStudentInboxMessagesCount,
  rejectStudentClubInvitation,
  acceptStudentClubInvitation
} from 'Src/helpers/service/student/messagesTable';
import { ParentFilterBar } from 'Src/components/ParentFilterBar/ParentFilterBar';
import { AppliedTextFilterChip } from 'Src/components/AppliedTextFilterChip/AppliedTextFilterChip';
import { WEEK_DAYS_SERVER_TO_CLIENT_MAPPING } from 'Src/consts/date';

interface Props {
  user: AppUser;
  history: History;
  location: Location;
  setNeedUpdate: () => void;
  onSectionCountsChange?: () => void;
}

interface State {
  items: EventInvitationMessage[];
  selectedItem: EventInvitationMessage | undefined;
  total: number;
  currentPage: number;
  filters: any;
  sortFieldName: string;
  sortDirection: string;
  isFiltersOpen: boolean;
  isLoading: boolean;
  basePath: string;
  isViewMapModalOpen: boolean;
  isDeclineModalOpen: boolean;
  isAcceptModalOpen: boolean;
  isShowDetailsModalOpen: boolean;
}

const ALL_DAYS = ['MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY', 'SUNDAY'];

const FILTER_FIELDS_STUDENT: ColumnDefinition[] = [
  { text: 'Club name', field: 'clubName', type: FILTER_TYPE.TEXT, accessor: [''], isSort: false },
  { text: 'Sport', field: 'sport', type: FILTER_TYPE.TEXT, accessor: [''], isSort: false },
  { text: 'Invitation date', field: 'createdAt', type: FILTER_TYPE.DATE_INTERVAL, accessor: [''], isSort: true },
  { text: 'Days', field: 'days', type: FILTER_TYPE.MULTISELECT, accessor: [''], isSort: false }
];

export class ClubBookingsInbox extends Component<Props, State> {
  private answeredMessageIds = new Set<string>();

  constructor(props) {
    super(props);
    this.state = {
      items: [],
      selectedItem: undefined,
      total: 0,
      currentPage: FIRST_PAGE,
      filters: {},
      sortFieldName: '',
      sortDirection: '',
      isFiltersOpen: false,
      isLoading: false,
      basePath: '',
      isViewMapModalOpen: false,
      isDeclineModalOpen: false,
      isAcceptModalOpen: false,
      isShowDetailsModalOpen: false
    };
  }

  componentDidMount() {
    this.setState({ isLoading: true });
    this.setItems();
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.location.search !== this.props.location.search) {
      this.setState({ isLoading: true });
      this.setItems();
    }
  }

  private normalizeFiltersForQuery = (f: any) => {
    const src = { ...(f || {}) };
    const out: any = {};

    const trimOrUndef = (v?: any) => {
      if (typeof v === 'string') {
        const s = v.trim();
        return s || undefined;
      }
      if (v && typeof v === 'object') {
        const like = String((v as any).like ?? (v as any).$regex ?? '').trim();
        return like || undefined;
      }
      return undefined;
    };

    const toIso = (s?: string) => {
      if (!s) return s;
      const m1 = s.match(/^(\d{2})[\/-](\d{2})[\/-](\d{4})$/);
      const m2 = s.match(/^(\d{4})-(\d{2})-(\d{2})$/);
      if (m1) return `${m1[3]}-${m1[2]}-${m1[1]}`;
      if (m2) return s;
      return s;
    };

    const clubName = trimOrUndef(src.clubName);
    const sport = trimOrUndef(src.sport);
    if (clubName) out.clubName = clubName;
    if (sport) out.sport = sport;

    if (typeof src.createdAt === 'string') {
      out.createdAt = { from: toIso(src.createdAt), to: undefined };
    } else if (src.createdAt && (src.createdAt.from || src.createdAt.to)) {
      out.createdAt = { from: toIso(src.createdAt.from), to: toIso(src.createdAt.to) };
    }

    if (Array.isArray(src.days)) {
      const norm = src.days
        .map((d: string) =>
          String(d)
            .trim()
            .toUpperCase()
        )
        .filter(Boolean);
      if (norm.length) out.days = norm;
    } else if (typeof src.days === 'string') {
      const v = String(src.days)
        .trim()
        .toUpperCase();
      if (v) out.days = [v];
    }

    return out;
  };

  private setItems() {
    const { history, user } = this.props;
    const search = parse(history.location.search);

    const page = typeof search.page !== 'undefined' ? Number(search.page) : FIRST_PAGE;

    let sortDirection = '' as TABLE_SORT_DIRECTION;
    let sortFieldName = '';
    if (typeof search.order === 'string') {
      const [field, dir] = (search.order as string).split(':');
      sortFieldName = field || '';
      sortDirection = (dir as TABLE_SORT_DIRECTION) || ('' as TABLE_SORT_DIRECTION);
    }

    const sortByFieldExist = !!sortFieldName;
    const sortDirectionExist = !!sortDirection;

    const rawFilters = getFilters2(FILTER_FIELDS_STUDENT, search);

    const likeFromUrl = (key: string): string | undefined => {
      const blob = propz.get(search, ['filter']);
      if (!blob) return undefined;
      try {
        const parsed = JSON.parse(decodeURIComponent(String(blob)));
        const v = parsed?.where?.[key];
        if (!v) return undefined;
        if (typeof v === 'string') return v.trim() || undefined;
        if (typeof v === 'object') {
          return String(v.like ?? v.$regex ?? '').trim() || undefined;
        }
        return undefined;
      } catch {
        return undefined;
      }
    };

    const daysFromUrl = propz.get(search, ['filter'])
      ? (() => {
          try {
            const parsed = JSON.parse(decodeURIComponent(String(search.filter)));
            return Array.isArray(parsed.where?.days) ? parsed.where.days : undefined;
          } catch {
            return undefined;
          }
        })()
      : undefined;

    const clubNameFromUrl = likeFromUrl('clubName');
    const sportFromUrl = likeFromUrl('sport');

    const uiFiltersBase = {
      ...rawFilters,
      ...(daysFromUrl ? { days: daysFromUrl } : {}),
      ...(clubNameFromUrl ? { clubName: clubNameFromUrl } : {}),
      ...(sportFromUrl ? { sport: sportFromUrl } : {})
    };

    const filtersForQuery = this.normalizeFiltersForQuery(uiFiltersBase);
    const { createdAt, ...rest } = filtersForQuery;

    const where = {
      kind: 'ClubParticipantInviteMessage',
      ...rest,
      ...(createdAt && (createdAt.from || createdAt.to) ? { createdAt } : {})
    };

    const order = sortByFieldExist && sortDirectionExist ? `${sortFieldName} ${sortDirection}` : undefined;

    const serverQueryFilter = getServerQueryFilter2(page, where, order, CARD_LIMIT);

    const getItemsPromise = getStudentInboxMessages(user, serverQueryFilter);
    const getItemsCountPromise = getStudentInboxMessagesCount(user, where);

    return BPromise.all([getItemsPromise, getItemsCountPromise]).then(([clubBookings, clubBookingsCountObj]) => {
      const visibleClubBookings = clubBookings.filter(item => !this.answeredMessageIds.has(String(item.id)));
      const hiddenAnsweredCount = clubBookings.length - visibleClubBookings.length;
      this.setState({
        items: visibleClubBookings,
        currentPage: page,
        filters: uiFiltersBase,
        sortDirection,
        sortFieldName,
        total: Math.max(0, Number(clubBookingsCountObj.count) - hiddenAnsweredCount),
        basePath: history.location.pathname,
        isLoading: false
      });
    });
  }

  private setCurrentPageParams = (currentPage: number): void => {
    const { sortFieldName, sortDirection } = this.state;
    const parts: string[] = [];

    if (currentPage !== 1) parts.push(`page=${currentPage}`);
    if (isSortExist(sortDirection, sortFieldName)) parts.push(getSearchOrder(sortDirection, sortFieldName));

    const filtersForUrl = this.normalizeFiltersForQuery(this.state.filters);
    if (isFilterExist2(filtersForUrl)) parts.push(getSearchFilter(filtersForUrl));

    this.props.history.push({ pathname: this.state.basePath, search: parts.join('&') });
  };

  private onTableFilterChange = (event, filterField: string, options?): void => {
    const filterValue = propz.get(event, ['target', 'value'], '');
    const { filters } = this.state;
    const currentFilterField = filters[filterField];

    let nextFilters = { ...filters };

    if (typeof options !== 'undefined') {
      switch (options) {
        case DATE_INTERVAL.FROM:
          nextFilters = { ...nextFilters, [filterField]: { ...currentFilterField, from: filterValue } };
          break;
        case DATE_INTERVAL.TO:
          nextFilters = { ...nextFilters, [filterField]: { ...currentFilterField, to: filterValue } };
          break;
      }
    } else {
      const def = FILTER_FIELDS_STUDENT.find(col => col.field === filterField);
      if (def?.type === FILTER_TYPE.MULTISELECT) {
        const optionsEl = event.target.options;
        const value: string[] = [];
        for (let i = 0; i < optionsEl.length; i++) {
          if (optionsEl[i].selected) value.push(optionsEl[i].value);
        }
        nextFilters = { ...nextFilters, [filterField]: value };
      } else {
        nextFilters = { ...nextFilters, [filterField]: filterValue };
      }
    }

    this.setState({ filters: nextFilters });
  };

  private toggleDay = (day: string) => {
    const d = day.toUpperCase();
    this.setState(prev => {
      const cur: string[] = Array.isArray(prev.filters.days) ? prev.filters.days : [];
      const exists = cur.includes(d);
      const next = exists ? cur.filter(x => x !== d) : [...cur, d];
      const nextFilters = { ...prev.filters };
      if (next.length) nextFilters.days = next;
      else delete nextFilters.days;
      return { filters: nextFilters };
    });
  };

  private onApplyFilterClick = (): void => {
    const { sortDirection, sortFieldName } = this.state;
    const parts: string[] = [];

    if (isSortExist(sortDirection, sortFieldName)) parts.push(getSearchOrder(sortDirection, sortFieldName));

    const filtersForUrl = this.normalizeFiltersForQuery(this.state.filters);
    if (isFilterExist2(filtersForUrl)) parts.push(getSearchFilter(filtersForUrl));

    this.props.history.push({ pathname: this.state.basePath, search: parts.join('&') });
  };

  private onClearFilterClick = (): void => {
    this.props.history.push({ pathname: this.state.basePath, search: '' });
  };

  private onBookNowClick = (fields: MessageField[], priority: number, submission?: FormSubmission) => {
    const { user, setNeedUpdate, onSectionCountsChange } = this.props;
    const { selectedItem } = this.state;

    this.setState({ isLoading: true });

    const data = { fields, priority, ...(submission || {}) };

    const messageId = String(selectedItem!.id);
    acceptStudentClubInvitation(user, messageId, data).then(() => {
      this.answeredMessageIds.add(messageId);
      this.setState({ isAcceptModalOpen: false, selectedItem: undefined });
      this.setItems().then(() => {
        setNeedUpdate();
        if (onSectionCountsChange) onSectionCountsChange();
      });
    });
  };

  private onAddToWaitingListClick = () => {
    const { user, setNeedUpdate, onSectionCountsChange } = this.props;
    const { selectedItem } = this.state;

    const messageId = String(selectedItem!.id);
    setMessageWaitingStatus(user, messageId).then(() => {
      this.answeredMessageIds.add(messageId);
      this.setState({ isAcceptModalOpen: false, selectedItem: undefined });
      this.setItems().then(() => {
        setNeedUpdate();
        if (onSectionCountsChange) onSectionCountsChange();
      });
    });
  };

  private renderAcceptClubBookingModal = () => {
    const { user } = this.props;
    const { isAcceptModalOpen, selectedItem } = this.state;

    return (
      <SimpleModal
        isOpen={isAcceptModalOpen}
        title="Book this club"
        customClass="parentCompactModal"
        onCloseClick={this.closeAcceptClubBookingModal}
        showFooter={false}
      >
        <ClubInvitationForm
          user={user}
          message={selectedItem}
          onBookNowClick={this.onBookNowClick}
          onAddToWaitingListClick={this.onAddToWaitingListClick}
          closeClubInvitationModal={this.closeAcceptClubBookingModal}
          onDeclineClick={this.openDeclineFromAcceptModal}
        />
      </SimpleModal>
    );
  };

  private openAcceptClubBookingModal = message => {
    this.setState({ isAcceptModalOpen: true, selectedItem: message });
  };
  private closeAcceptClubBookingModal = () => {
    this.setState({ isAcceptModalOpen: false, selectedItem: undefined });
  };

  private openDeclineFromAcceptModal = () => {
    this.setState({ isAcceptModalOpen: false, isDeclineModalOpen: true });
  };

  private onDeclineClubBookingClick = () => {
    const { user, setNeedUpdate, onSectionCountsChange } = this.props;
    const { selectedItem } = this.state;

    this.setState({ isLoading: true });

    const messageId = String(selectedItem!.id);
    rejectStudentClubInvitation(user, messageId).then(() => {
      this.answeredMessageIds.add(messageId);
      this.setState({ isDeclineModalOpen: false, selectedItem: undefined });
      this.setItems().then(() => {
        setNeedUpdate();
        if (onSectionCountsChange) onSectionCountsChange();
      });
    });
  };

  private openDeclineClubBookingModal = message => this.setState({ isDeclineModalOpen: true, selectedItem: message });
  private closeDeclineClubBookingModal = () => this.setState({ isDeclineModalOpen: false, selectedItem: undefined });

  private renderDeclineClubBookingModal = () => {
    const { isDeclineModalOpen, selectedItem } = this.state;
    if (!selectedItem) return null;

    const clubName = propz.get(selectedItem, ['clubData', 'name'], '');

    const placeName = propz.get(selectedItem, ['clubData', 'venue', 'placeData', 'name'], '');
    const postcodeA = propz.get(selectedItem, ['clubData', 'venue', 'placeData', 'postcode'], '');
    const postcodeB = propz.get(selectedItem, ['clubData', 'venue', 'postcodeData', 'postcode'], '');
    const venue = [placeName, postcodeA || postcodeB].filter(Boolean).join(', ');

    const startDate = propz.get(selectedItem, ['clubData', 'startDate']);
    const finishDate = propz.get(selectedItem, ['clubData', 'finishDate']);
    const runStart = startDate ? moment(startDate).format('D MMM YYYY') : '';
    const runEnd = finishDate ? moment(finishDate).format('D MMM YYYY') : '';
    const sameDay = startDate && finishDate && moment(startDate).isSame(finishDate, 'day');
    const runText = runStart ? (sameDay ? runStart : runEnd ? `${runStart} – ${runEnd}` : runStart) : runEnd || '';

    const days = propz.get(selectedItem, ['clubData', 'days'], []);
    const daysText =
      Array.isArray(days) && days.length
        ? days.map(day => WEEK_DAYS_SERVER_TO_CLIENT_MAPPING[day] || day).join(', ')
        : '';
    const timeISO = propz.get(selectedItem, ['clubData', 'time']);
    const durationMin = propz.get(selectedItem, ['clubData', 'duration'], 0);
    const startMs = timeISO ? new Date(timeISO).getTime() : undefined;
    const endISO = typeof startMs === 'number' ? new Date(startMs + durationMin * 60 * 1000).toISOString() : undefined;
    const timeRange = timeISO
      ? `${moment(timeISO).format('HH:mm')}${endISO ? `–${moment(endISO).format('HH:mm')}` : ''}`
      : '';
    const whenText = [daysText, timeRange].filter(Boolean).join(' • ');

    return (
      <SimpleModal
        isOpen={isDeclineModalOpen}
        onCloseClick={this.closeDeclineClubBookingModal}
        onBackdropClick={this.closeDeclineClubBookingModal}
        showFooter={false}
        isBodyBold={false}
        customClass="DeclineModal"
        dialogStyle={{ maxWidth: 520 }}
        title="Confirm decline"
      >
        <div className="DeclineModal__header">
          <div className="DeclineModal__icon" aria-hidden="true">
            !
          </div>
          <div className="DeclineModal__titles">
            <h3>Decline this invitation?</h3>
            <p>
              If you decline, the organiser will be notified that you won&apos;t attend <strong>{clubName}</strong>.
            </p>
          </div>
        </div>

        <div className="DeclineModal__summary">
          <div className="DeclineModal__row">
            <span className="label">Club</span>
            <span className="value">{clubName || '—'}</span>
          </div>
          {runText && (
            <div className="DeclineModal__row">
              <span className="label">Run</span>
              <span className="value">{runText}</span>
            </div>
          )}
          {whenText && (
            <div className="DeclineModal__row">
              <span className="label">When</span>
              <span className="value">{whenText}</span>
            </div>
          )}
          {venue && (
            <div className="DeclineModal__row">
              <span className="label">Where</span>
              <span className="value">{venue}</span>
            </div>
          )}
        </div>

        <div className="DeclineModal__cta">
          <button type="button" onClick={this.closeDeclineClubBookingModal}>
            Go back
          </button>
          <button type="button" className="is-danger" onClick={this.onDeclineClubBookingClick}>
            Decline invitation
          </button>
        </div>
      </SimpleModal>
    );
  };

  private renderViewMapModal = () => {
    const { isViewMapModalOpen, selectedItem } = this.state;
    const point = propz.get(selectedItem, ['clubData', 'venue', 'placeData', 'point']);

    return (
      <SimpleModal
        isOpen={isViewMapModalOpen}
        onCloseClick={this.closeViewMapModal}
        title="View map"
        customClass="parentCompactModal"
      >
        <Map point={point} customStylingClass="eChildEventVenueMap" isMarkerDraggable={false} />
      </SimpleModal>
    );
  };
  private openViewMapModal = message => this.setState({ isViewMapModalOpen: true, selectedItem: message });
  private closeViewMapModal = () => this.setState({ isViewMapModalOpen: false, selectedItem: undefined });

  private renderShowDetailsModal = () => {
    const { isShowDetailsModalOpen, selectedItem } = this.state;
    return (
      <SimpleModal
        isOpen={isShowDetailsModalOpen}
        onCloseClick={this.closeShowDetailsModal}
        title="Club details"
        side="right"
        showFooter={false}
      >
        <ClubBookingDeatils message={selectedItem} />
      </SimpleModal>
    );
  };
  private openShowDetailsModal = message => this.setState({ isShowDetailsModalOpen: true, selectedItem: message });
  private closeShowDetailsModal = () => this.setState({ isShowDetailsModalOpen: false, selectedItem: undefined });

  render() {
    const { isLoading, isFiltersOpen, total, currentPage, items, filters } = this.state;

    if (isLoading) return <Loader />;

    const selectedDays: string[] = Array.isArray(filters.days) ? filters.days : [];

    return (
      <div className="studentClubInvitesContent">
        {this.renderDeclineClubBookingModal()}
        {this.renderAcceptClubBookingModal()}
        {this.renderViewMapModal()}
        {this.renderShowDetailsModal()}

        <div className="studentHubControls">
          <div className="parentListSearch">
            <input
              type="search"
              className="form-control"
              placeholder="Search club name…"
              aria-label="Search by club name"
              value={filters.clubName || ''}
              onChange={e => this.onTableFilterChange(e, 'clubName')}
              onKeyDown={e => {
                if (e.key === 'Enter') this.onApplyFilterClick();
              }}
            />
          </div>
          <button
            className={isFiltersOpen ? 'parentFilterButton is-active' : 'parentFilterButton'}
            onClick={() => this.setState(prev => ({ isFiltersOpen: !prev.isFiltersOpen }))}
          >
            <span className="parentFilterButton__icon" aria-hidden="true" /> Filters
          </button>

          <Pagination2
            currentPage={currentPage}
            total={total}
            setCurrentPageParams={this.setCurrentPageParams}
            limit={CARD_LIMIT}
            modern
          />
        </div>

        <AppliedTextFilterChip
          history={this.props.history}
          location={this.props.location}
          filters={[
            { filterKey: 'clubName', label: 'Club name' },
            { filterKey: 'sport', label: 'Sport' },
            { filterKey: 'createdAt', label: 'Invitation date', type: 'date' },
            {
              filterKey: 'days', label: 'Days', type: 'multi',
              valueLabels: {
                MONDAY: 'Monday', TUESDAY: 'Tuesday', WEDNESDAY: 'Wednesday', THURSDAY: 'Thursday',
                FRIDAY: 'Friday', SATURDAY: 'Saturday', SUNDAY: 'Sunday'
              }
            }
          ]}
        />

        {isFiltersOpen && (
          <ParentFilterBar
            filters={filters}
            showTextFilter={false}
            onTableFilterChange={this.onTableFilterChange}
            onApply={this.onApplyFilterClick}
            onClear={this.onClearFilterClick}
            onCancel={() => this.setState({ isFiltersOpen: false })}
            labels={{ text: 'Club name', secondText: 'Activity/Sport', date: 'Invitation date' }}
            fieldKeys={{ textKey: 'clubName', secondTextKey: 'sport', dateKey: 'createdAt' }}
            extraFilters={
              <div className="parentFilterDrawer__field">
                <label className="form-label">Days of week</label>
                <div className="studentHubFilterChips">
                  {ALL_DAYS.map(d => {
                    const active = selectedDays.includes(d);
                    return (
                      <button
                        key={d}
                        type="button"
                        className={active ? 'studentHubFilterChip is-active' : 'studentHubFilterChip'}
                        onClick={() => this.toggleDay(d)}
                      >
                        {WEEK_DAYS_SERVER_TO_CLIENT_MAPPING[d] || d.charAt(0) + d.slice(1).toLowerCase()}
                      </button>
                    );
                  })}
                  {selectedDays.length > 0 && (
                    <button
                      type="button"
                      className="studentHubFilterChip"
                      onClick={() => {
                        this.setState(prev => {
                          const next = { ...prev.filters };
                          delete next.days;
                          return { filters: next };
                        });
                      }}
                    >
                      Clear days
                    </button>
                  )}
                </div>
              </div>
            }
          />
        )}

        {items.length === 0 ? (
          <div className="studentHubEmpty">
            <span className="studentHubEmpty__icon">C</span>
            <strong>No club invitations</strong>
            <p>New invitations will appear here when a club is offered to you.</p>
          </div>
        ) : (
          <div className="row gap-3 mt-2">
            {items.map(item => {
              const { id } = item;
              return (
                <div className="col-12 col-sm-6 col-lg-4 mb-4" key={id}>
                  <ClubBookingCard
                    user={this.props.user}
                    item={item}
                    type={INVITE_TYPE.INBOX}
                    onDeclineClick={this.openDeclineClubBookingModal}
                    onBookClick={this.openAcceptClubBookingModal}
                    onViewMapClick={this.openViewMapModal}
                    onShowDetailsClick={this.openShowDetailsModal}
                  />
                </div>
              );
            })}
          </div>
        )}
      </div>
    );
  }
}
